
import axios from "axios";
import check from "~/store/elementChecker";
export default {
  async asyncData({ app, req, context, route, store }) {
    let host = "";
    if (process.server) {
      host = req.headers.host + route.fullPath;
    } else {
      host = location.host + route.fullPath;
    }
    let preview = "";
    if (app.$cookies.get("preview")) {
      let pr = (app.$cookies.get("preview") || "").split(":::");
      if (pr[1] == store.getters.store.id) {
        preview = `&preview=${pr[0]}`;
      }
    }
    // check(
    //   store.getters.store.id,
    //   route,
    //   app,
    //   preview,
    //   ((store.getters.store || {}).build_no || {}).timestamp,
    //   (store.getters.store.build || {}).build_no
    // );
    try {
      let res = await axios.get(
        `${process.env.axiosUrl}/stores/${
          store.getters.store.id
        }?elements=cart,${encodeURIComponent("Καλάθι")}&build=${
          (store.getters.store.build || {}).build_no
        }&elementsonly=true${preview}`,
        {
          headers: {
            shopster: host,
          },
        }
      );
      if ((res.data || {}).id) {
        store.commit("elements", [
          ...store.getters.store.eshop.elements.filter((e) => e.static),
          ...res.data.eshop.elements,
        ]);

        let es = JSON.parse(JSON.stringify(store.getters.store));
        es.eshop.elements =
          (await app.$hyperElement.populateData({ page: "cart", app })) || [];
        store.commit("store", es);
      }
    } catch (e) {
      console.error(e);
    }
  },
  async mounted() {
    await this.$store.dispatch("prepareElements", {
      state: this.$store.state,
      cart: 1,
      elements: this.$store.getters.elements,
      app: this.$nuxt,
    });

    if(process.browser){
      if(!(this.$route.params || {}).step){
        this.$nuxt.$emit('informant:view_cart',this.$store.getters.cart)
      }
      else if((this.$route.params || {}).step == 'checkout'){
        this.$nuxt.$emit('informant:begin_checkout',this.$store.getters.cart)
      }
    }
  },
  head() {
    return {
      title: "Καλάθι",
    };
  },
};
